import react, { Component } from 'react';
import { DKLabel, DKButton, showToast, TOAST_TYPE, DKSpinner, DKCalendar, DKIcon, DKIcons, DKLine, DKInput, INPUT_VIEW_DIRECTION, Toggle } from "deskera-ui-library";
import RouteManager from '../../../../managers/RouteManager';
import date_range from "../../../../assets/icons/white/date_range.svg";
import moment from 'moment';
import { COUNTRY_CODE, DATE_FORMAT, INPUT_TYPE } from '../../../../constants/Constant';
import PayrollService from '../../../../services/PayrollService';
import ReportService from '../../../../services/ReportService';
import { saveAs } from 'file-saver';
import { TENANT, TenantService } from '../../../../managers/TenantManagerService';
import { getCPFYears } from '../../../../managers/common/CommonUtil';
import Utility from '../../../../utility/Utility';
export default class W4FormsForEmployee extends Component {
    selectedUser = {};
    isAdmin = TenantService.get(TENANT.IS_ADMIN);
    yearOptions = getCPFYears();
    selectedYear = moment().format("YYYY");
    formType = 'W4';
    constructor(props) {
        super(props)
        this.state = {
            users: [],
            canValidate: false
        }
        if (this.isAdmin) {
            this.getUsers();
        }
    }
    componentDidMount() {
        RouteManager.setPresenter(this);
        this.isAdmin = TenantService.get(TENANT.IS_ADMIN);
    }
    async getUsers() {
        const response = await PayrollService.getUsersList();
        if (response['status'] == 'OK') {

            this.setState({
                users: response['users'],

            })
        }
    }
    export() {
        this.setState({ ...this.state })
        let users = []
        let fileName = this.formType;
        if (this.isAdmin) {
            if (this.selectedUser.length == 0 && !Utility.isEmpty(this.selectedYear)) {
                this.setState(
                    {
                        ...this.state,
                        canValidate: true
                    }
                )
                return
            }

            this.selectedUser.forEach(ind => {
                users.push(ind.userId)
                fileName = `${this.formType}_${ind.employeeId}_${ind.firstName}_${ind.lastName}`
            })

            
        } else {
            users.push(TenantService.get(TENANT.USER_ID));
            fileName = `${this.formType}_${TenantService.get(TENANT.FIRST_NAME)}_${TenantService.get(TENANT.LAST_NAME)}`
        }
        let parameters = this.getParameters(users);


        ReportService.downloadStateForm("FORMW4", parameters).then(
            (response) => {

                saveAs(response, fileName);
                showToast("Download completed", TOAST_TYPE.SUCCESS);
            }, (error) => {
                showToast("Internal Server Error", TOAST_TYPE.FAILURE);
            }
        )
    }

    getParameters(users) {
        let params = {
            userId: users[0],
            year: this.selectedYear,
        };
        return params;
    }

    render() {
        return (
            <div className="parent-width">
                <DKLabel text="W4 Form for Employees" className="fw-m fs-l" />
                <div className="bg-white pb-l card-shadow mt-l">
                    <DKLabel text="W4 Form for Employees" className="fw-m fs-l p-l" />
                    <DKLine className="bg-gray3  " />
                    <div className="d-flex p-h-l">
                        {this.isAdmin && (
                            <div className="" style={{ width: "35%" }}>
                                {this.state.users.length === 0 && (
                                    <div
                                        style={{ marginLeft: "-348px", marginBottom: "-22px" }}
                                    >
                                        <DKSpinner className="" />
                                    </div>
                                )}
                                <DKInput
                                    value={
                                        this.selectedUser.length === 0
                                            ? {}
                                            : this.selectedUser[0]
                                    }
                                    formatter={(obj) => {
                                        /** How to render a selected option in case of object **/
                                        return obj.name;
                                    }}
                                    title="Employee"
                                    type={INPUT_TYPE.DROPDOWN}
                                    showError={false}
                                    direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                    required={true}
                                    errorMessage="Please select employee"
                                    canValidate={true}
                                    options={this.state.users}
                                    onChange={(value) => {
                                        this.selectedUser = []
                                        this.selectedUser.push(value);
                                    }}
                                    dropdownConfig={{
                                        className: "",
                                        style: {},
                                        allowSearch:
                                            this.state.users && this.state.users.length > 6
                                                ? true
                                                : false,
                                        searchableKey: "name",
                                        data: this.state.users,
                                        renderer: (index, obj) => {
                                            /** How to render value in Dropdown in case of object **/
                                            return <DKLabel text={`${obj.name}`} />;
                                        },
                                        onSelect: (index, obj) => {
                                            // onValueChange(obj, "Quarter");
                                        },
                                    }}
                                />
                            </div>
                        )}
                        <div className="p-h-l" style={{ width: "35%" }}>
                            <DKInput
                                title="Year"
                                value={this.selectedYear} // Value should be complete string
                                formatter={(obj) => {
                                    // How to render selected value from strig of Array
                                    return obj;
                                }}
                                type={INPUT_TYPE.DROPDOWN}
                                required={true}
                                canValidate={true}
                                readOnly={false}
                                direction={INPUT_VIEW_DIRECTION.VERTICAL}
                                options={this.yearOptions}
                                errorMessage="Please select year"
                                onChange={(value) => {
                                    this.selectedYear = value;
                                }}
                                dropdownConfig={{
                                    className: "",
                                    style: {},
                                    allowSearch: false,
                                    searchableKey: undefined,
                                    data: this.yearOptions,
                                    renderer: (index, obj) => {
                                        // How to render dropdwon options from string of array
                                        return <DKLabel className="" text={obj} />;
                                    },
                                    onSelect: (index, value) => { },
                                }}
                            />
                        </div>
                        <div
                            className={`mb-xs ${this.isAdmin ? "mr-l" : ""}`}
                            style={{ marginTop: "25px" }}
                        >
                            <DKButton
                                title="DOWNLOAD FORM"
                                icon={DKIcons.white.ic_download}
                                className={`bg-app text-white ${this.isAdmin ? "ml-l" : ""
                                    }`}
                                onClick={() => {
                                    this.export();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}